<template>
    <div class="wrapper">
        <div class="section section-blogs-2 topsearch">
            <div class="container main">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <router-link :to="{ name: 'AllDicts' }" id="buttonback">
                            <md-icon>keyboard_arrow_left</md-icon>
                            Назад к справочникам
                        </router-link>
                    </div>
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <div class="name">
                            <h3 class="title">
                                Список доступных каналов продаж:
                            </h3>
                            <div
                                class="md-layout-item md-size-100 md-xsmall-size-100 savebtn"
                            >
                                <div class="md-layout">
                                    <div
                                        class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right"
                                    >
                                        <button
                                            class="md-button"
                                            type="button"
                                            @click="toggleShowOnlyActive"
                                        >
                                            <span class="md-ripple">
                                                {{
                                                    isShowOnlyActive
                                                        ? 'Отобразить неактивные'
                                                        : 'Скрыть неактивные'
                                                }}
                                            </span>
                                        </button>

                                        <router-link
                                            :to="{
                                                name: 'saleschannalItemData',
                                                params: { id: 'new' },
                                            }"
                                            class="md-primary"
                                            tag="md-button"
                                        >
                                            Добавить новый элемент
                                        </router-link>
                                    </div>
                                </div>
                                <md-card
                                    v-if="agencies.length > 0"
                                    class="md-card-plain"
                                >
                                    <md-card-content>
                                        <md-table
                                            class="table-shopping"
                                            v-model="agenciesFiltered"
                                        >
                                            <md-table-row
                                                slot="md-table-row"
                                                slot-scope="{ item }"
                                            >
                                                <md-table-cell
                                                    md-label="Название канала продаж"
                                                >
                                                    <router-link
                                                        :to="{
                                                            name:
                                                                'saleschannalItemData',
                                                            params: {
                                                                id: item.id,
                                                            },
                                                        }"
                                                    >
                                                        {{ item.chanName }}
                                                    </router-link>
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="UTM-метка"
                                                >
                                                    {{ item.utmSubstring }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="Источник"
                                                >
                                                    {{ item.sourceName }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="LeadType"
                                                >
                                                    {{
                                                        item.leadType
                                                            ? leadTypes[
                                                                  item.leadType
                                                              ].leadTypeCode
                                                            : ''
                                                    }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="Активность"
                                                >
                                                    {{
                                                        item.status === 'A'
                                                            ? 'Активный'
                                                            : 'Неактивный'
                                                    }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="ID источника(source_id)"
                                                >
                                                    {{ item.sourceId }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="ID офиса"
                                                >
                                                    {{ item.officeId }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="КЦ тел."
                                                >
                                                    {{ item.chanPhone }}
                                                </md-table-cell>
                                                <md-table-cell
                                                    md-label="Комментарий"
                                                >
                                                    {{ item.description }}
                                                </md-table-cell>
                                                <md-table-cell>
                                                    <router-link
                                                        :to="{
                                                            name:
                                                                'saleschannalItemData',
                                                            params: {
                                                                id: item.id,
                                                                action:
                                                                    'delete',
                                                            },
                                                        }"
                                                        event=""
                                                        @click.native.prevent="
                                                            confirmDelete({
                                                                name:
                                                                    'saleschannalItemData',
                                                                params: {
                                                                    id: item.id,
                                                                    action:
                                                                        'delete',
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <md-icon
                                                            >delete</md-icon
                                                        >
                                                    </router-link>
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </md-card-content>
                                </md-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { checkAuthentication, reAuthenticate } from '@/utils/auth-api';
import { getItem } from '@/utils/dict-api';

export default {
    bodyClass: 'model-list',
    data() {
        return {
            agencies: [],
            leadTypes: {},
            isShowOnlyActive:
                localStorage.getItem('sales_channel_show_only_active') ===
                'true',
        };
    },
    computed: {
        agenciesFiltered() {
            return this.isShowOnlyActive
                ? this.agencies.filter(item => item.status === 'A')
                : this.agencies;
        },
    },
    methods: {
        setAgencies() {
            checkAuthentication(this.$router, this.$route).then(response => {
                getItem('leadtype')
                    .then(result => {
                        this.leadTypes = {};
                        for (let leadType of result) {
                            this.leadTypes[leadType.id] = leadType;
                        }
                        checkAuthentication(this.$router, this.$route).then(
                            response => {
                                getItem('saleschannal')
                                    .then(result => {
                                        this.agencies = result;
                                    })
                                    .catch(error => {
                                        reAuthenticate(
                                            this.$router,
                                            this.$route,
                                            error
                                        );
                                    });
                            }
                        );
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        confirmDelete(route) {
            if (confirm('Действительно удалить?')) {
                this.$router.push(route);
            }
        },
        toggleShowOnlyActive() {
            this.isShowOnlyActive = !this.isShowOnlyActive;
            localStorage.setItem(
                'sales_channel_show_only_active',
                this.isShowOnlyActive
            );
        },
    },
    created() {
        this.setAgencies();
    },
};
</script>
<style lang="scss" scoped type="text/scss">
.savebtn {
    margin-right: 0;
    padding-right: 5px;
}
</style>
